"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionStatuses = void 0;
exports.permissionStatuses = ['unavailable', 'pending', 'denied', 'limited', 'granted', 'blocked'];
